import { Renderer } from '../model';
import { d3Svg } from './d3Svg';

export const renderer: Renderer = d3Svg;
